<script>
export default {
  name: "DeliveryUnitModal",
  data() {
    return {
      multiple: false,
      submitted: false,
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          sortable: true,
          tdClass: "Delivery Unit",
        },
        {
          key: "office",
          sortable: true,
          label: "Office",
          tdClass: "align-middle",
        },
        {
          key: "campus",
          sortable: true,
          label: this.GLOBAL_FROM_SCHOOL ? "Campus" : "Main Office",
          tdClass: "align-middle",
        },
      ],
      indexSelected: -1,
      tableBusy: false,
      toggleAll: false,
      selectedCampus: this.$store.state.data.selectedCampus.id,
    };
  },
  computed: {
    selectedDu() {
      return this.tableData.filter((row) => row.toggleDu);
    },
    campusFilter() {
      return this.tableData.filter((row) => {
        return row.office.campusId == this.selectedCampus;
      });
    },
    rows() {
      if (this.filter) {
        return this.totalRows;
      }
      return this.campusFilter.length;
    },
  },
  methods: {
    getSingleData() {
      this.selectedCampus = this.$store.state.data.selectedCampus.id;
      this.currentPage = 1;
      this.perPage = 10;
      this.filter = null;
      this.tableBusy = true;
      this.multiple = false;
      this.toggleAll = false;
      this.$store
        .dispatch("deliveryunit/GetDeliveryUnit")
        .then((res) => {
          this.tableBusy = false;
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something went wrong!", "error");
        });
    },
    getMultipleData() {
      this.selectedCampus = this.$store.state.data.selectedCampus.id;
      this.currentPage = 1;
      this.perPage = 10;
      this.filter = null;
      this.tableBusy = true;
      this.multiple = true;
      this.toggleAll = false;
      this.$store
        .dispatch("deliveryunit/GetDeliveryUnit")
        .then((res) => {
          res.data.forEach((item) => {
            item.toggleDu = false;
          });
          this.tableBusy = false;
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something went wrong!", "error");
        });
    },
    getFilteredMultipleData(data) {
      this.selectedCampus = this.$store.state.data.selectedCampus.id;
      this.currentPage = 1;
      this.perPage = 10;
      this.filter = null;
      this.tableBusy = true;
      this.multiple = true;
      this.toggleAll = false;
      this.$store
        .dispatch("deliveryunit/GetDeliveryUnit")
        .then((res) => {
          res.data.forEach((item) => {
            item.toggleDu = false;
            item.isOwner = false;
          });
          this.tableBusy = false;
          this.tableData = res.data.filter((item) => {
            var count = 0;
            for (var counter = 0; counter < data.length; counter++) {
              if (data[counter].id == item.id) count++;
            }
            return count == 0;
          });
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something went wrong!", "error");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleAllItems() {
      this.campusFilter.forEach((item) => {
        item.toggleDu = this.toggleAll === true ? true : false;
      });
    },
    checkToggle() {
      var count = 0;
      this.campusFilter.forEach((item) => {
        if (item.toggleDu) count++;
      });
      if (count === this.campusFilter.length) {
        this.toggleAll = true;
      } else {
        this.toggleAll = false;
      }
    },
    dropData(data) {
      if (data.length > 0) {
        if (this.multiple) {
          data[0].toggleDu = !data[0].toggleDu;
          this.$forceUpdate();
        } else {
          this.$emit("dropData", data[0]);
          this.$bvModal.hide("office-modal");
        }
      }
    },
    proceedChecking(selected) {
      this.$emit("dropMultiple", selected);
      this.$bvModal.hide("office-modal");
    },
  },
};
</script>
      
<template>
  <b-modal
    id="office-modal"
    title="Delivery Unit List"
    size="lg"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <div class="row mt-1">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <div
        class="col-md-6"
        v-if="$store.state.decrypt.campusAccessList().length > 1"
      >
        <select
          name="campusAccess"
          class="form-select form-select-sm"
          v-model="selectedCampus"
          @change="checkToggle()"
        >
          <option
            v-for="campus in $store.state.decrypt.campusAccessList()"
            :value="campus.Id"
            :key="campus.Id"
          >
            {{ campus.CampusName }}
          </option>
        </select>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="campusFilter"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        :busy="tableBusy"
        @filtered="onFiltered"
        bordered
        outlined
        hover
        striped
        show-empty
        :select-mode="multiple ? 'range' : 'single'"
        selectable
        @row-selected="dropData"
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #head(name)>
          <div
            v-if="multiple && !tableBusy && campusFilter.length > 0"
            class="form-check form-checkbox-outline form-check-success mb-0"
          >
            <input
              type="checkbox"
              id="toggleAll"
              checked="checked"
              class="form-check-input"
              @change="toggleAllItems()"
              v-model="toggleAll"
            /><label for="toggleAll" class="form-check-label">
              <div>Name</div>
            </label>
          </div>
          <div v-if="!multiple">Name</div>
        </template>
        <template #cell(name)="row">
          <div
            v-if="multiple"
            class="form-check form-checkbox-outline form-check-success mb-0"
          >
            <input
              type="checkbox"
              :id="`toggleDu-${row.item.id}`"
              checked="checked"
              class="form-check-input"
              @change="checkToggle()"
              v-model="row.item.toggleDu"
            /><label :for="`toggleDu-${row.item.id}`" class="form-check-label">
              <div>
                {{ row.item.name }}
              </div>
            </label>
          </div>
          
          <div class="ms-3 form-check form-checkbox-outline form-check-success mb-0"  v-if="multiple && row.item.toggleDu">
            <input
              type="checkbox"
              :id="`isOwnerDU-${row.item.id}`"
              checked="checked"
              class="form-check-input"
              v-model="row.item.isOwner"
            /><label :for="`isOwnerDU-${row.item.id}`" class="form-check-label">Process Owner?</label>
          </div>
          <div v-if="!multiple">
            {{ row.item.name }}
          </div>
        </template>
        <template #cell(office)="row">
          <div>
            {{ row.item.office.name }}
          </div>
        </template>
        <template #cell(campus)="row">
          <div>
            {{ row.item.office.campus.campusName }}
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="position-fixed fix-top-middle"
      v-if="multiple && selectedDu.length > 0"
    >
      <button
        type="button"
        class="btn btn-success text-truncate"
        @click="proceedChecking(selectedDu)"
      >
        Proceed with {{ selectedDu.length }} selected Delivery Units
      </button>
    </div>
  </b-modal>
</template>